import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { AppSettings } from '../../../shared/app.settings';
import { StorageService } from './../../services/storage.service';
import { LoaderService } from './../../components/loader/loader.service';
import { CommonBindingDataService } from './../../services/common-binding-data.service';
import { HttpHeaders } from '@angular/common/http';
import { RestApiService } from '../../services/rest-api.service';
import { ErrorBindingService } from '../../services/error-binding.service';


@Component({
    selector: 'app-file-uploader',
    templateUrl: './file.uploader.component.html',
    standalone: false
})
export class FileUploaderComponent implements OnInit {

  @Input() accept;
  @Input() uploadButtonLabel;
  @Output() onFileUpload: EventEmitter<any> = new EventEmitter();
  @Output() onFileUploadEvent: EventEmitter<any> = new EventEmitter();
  maxSize = AppSettings.FILE_UPLOAD_MAX_SIZE_IN_BYTE;
  fileUploadUrl: string = AppSettings.FILE_UPLOAD_ROUTE;
  maxSizeMessage;

  constructor(
    private storageService: StorageService,
    private loaderService: LoaderService,
    private commonService: CommonBindingDataService,
    private restApiService: RestApiService,
    private errorBindingService: ErrorBindingService) {
  }

  ngOnInit() {
    this.maxSizeMessage = this.commonService.getLabel('file_size_limit');
  }


  onUpload(event) {
    this.onFileUploadEvent.emit(event);
    const xhr = event.xhr;
    const response = JSON.parse(xhr.response);
    this.onFileUpload.emit(response);
    this.loaderService.hide();
  }

  public onFileUploading(data: { files: File }): void {
    this.loaderService.show('page-center')
    const formData: FormData = new FormData();
    const file = data.files[0];
    formData.append('file[]', file, file.name);

    const authHeader = AppSettings.HEADER_AUTHORIZATION;
    const options = {};
    options[authHeader] = this.storageService.getItemFromCookies(AppSettings.TOKEN_KEY);

    this.restApiService.post(this.fileUploadUrl, formData, 'page-data', { headers: new HttpHeaders(options) }).subscribe(response => {
      this.loaderService.hide();
      this.onFileUpload.emit(response);
    }, error => {
    })
  }

  onBeforeSend(event) {
    const xhr = event.xhr;
    if (xhr) {
      xhr.setRequestHeader(AppSettings.HEADER_AUTHORIZATION, this.storageService.getItemFromCookies(AppSettings.TOKEN_KEY));
      this.loaderService.show('page-center');
    }
  }

  onUploadError(event: any) {
    this.errorBindingService.setMessage({ severity: 'error', summary: 'Error', detail: this.commonService.getLabel('file_upload_error') });
    this.loaderService.hide();
  }
}
